// Cookie key value
export const ENVIRONMENT_COOKIE_KEY = 'ENVIRONMENT';

// Session storage key value
export const LOGIN_REDIRECT_KEY = 'LOGIN_REDIRECT';

// Permissions
export const Permissions = {
    WRITE_MED_BILLING: 'write:med_billing',
} as const;

export const PlaceOfServiceCode = {
    FACILITY: 'FACILITY',
    HOME: 'HOME',
    INFU_INFU: 'INFU_INFU',
    INFU_SPEC: 'INFU_SPEC',
    PHYS_PHYS: 'PHYS_PHYS',
    PHYS_SPEC: 'PHYS_SPEC',
} as const;
